import IframeActivity from "./IframeActivity";

export default function Breadcrumbs() {
    return (
        <IframeActivity
            src="/activities/breadcrumbs/index.html"
            title="Breadcrumbs"
        />
    );
}